export default __webpack_public_path__ + "static/media/bb1.2.965f8cf1.png";